import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <ul>
      <li>
        <Link to="/products"
          style={{
            marginBottom: "100px"
          }}
        >See products</Link>
      </li>
      <li>
        <Link to="/form"
          style={{
            marginBottom: "100px"
          }}
        >contact form</Link>
      </li>
    </ul>
  </Layout>
)

export default IndexPage
